import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private _router: Router,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // When the API response contains a UTF-8 BOM (﻿) at position 0, Angular's
        // JSON parser fails even though the HTTP status is 200. Browsers strip BOM
        // automatically; Node.js (xhr2 used in SSR) does not. Strip and re-parse.
        if (
          err.status === 200 &&
          err.error?.text &&
          typeof err.error.text === 'string'
        ) {
          const stripped = err.error.text.replace(/^\uFEFF/, '');
          try {
            const parsed = JSON.parse(stripped);
            return of(new HttpResponse({ status: 200, body: parsed, headers: err.headers, url: err.url }));
          } catch {}
        }

        const isAuthRequest =
          request.url.includes('/auth/login') ||
          request.url.includes('/auth/link-login') ||
          request.url.includes('/auth/signup');

        if (
          err.status === 401 &&
          !isAuthRequest &&
          !request.url.includes('create-booking-attempt', 0) &&
          err?.error?.message !== 'Unauthorized'
        ) {
          this.authenticationService.logout();
          this._router.navigateByUrl(
            'auth/login?redirect_url=' + this._router.url,
          );
        }

        return throwError(err);
      }),
    );
  }
}
